import { connect } from 'react-redux'

import DeleteContactView from './DeleteContactView.jsx';
import { deleteContact } from 'src/legacy/redux/actions/rolodex.jsx';

const mapStateToProps = (state,ownProps) => {
  return {
    contact: state.legacyRootReducer.rolodex.contact.item,
    contacts: state.legacyRootReducer.rolodex.items,
    deleting: state.legacyRootReducer.rolodex.contact.deleting
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteContact: (contactList, id) => {
      return dispatch(deleteContact(contactList, id));
    }
  }
}

const DeleteContactContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteContactView)

export default DeleteContactContainer;